import { render } from "./ClueGoView.vue?vue&type=template&id=00c8145a&scoped=true&ts=true"
import script from "./ClueGoView.vue?vue&type=script&lang=ts"
export * from "./ClueGoView.vue?vue&type=script&lang=ts"

import "./ClueGoView.vue?vue&type=style&index=0&id=00c8145a&scoped=true&lang=scss"

import exportComponent from "C:\\vue项目\\fushuliang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00c8145a"]])

export default __exports__